module.exports = __webpack_public_path__ + "img/logo.83fc61f6.png";